"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LabelContent = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    forId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
    ref: ref,
    htmlFor: forId,
    style: staticStyles.inheritCursor,
    children: children
  });
});
LabelContent.displayName = 'LabelContent';
LabelContent.propTypes = {
  children: _propTypes.default.string,
  forId: _propTypes.default.string
};

// Note that <label> is not React Native, so we can't use `StyleSheet.create` here
const staticStyles = {
  inheritCursor: {
    cursor: 'inherit'
  }
};
var _default = exports.default = LabelContent;